import { ECompanyType, IPageParam } from '../common';

export interface IGroupAduit {
  /** 申请id */
  id: number;
  /** 企业名称 */
  companyName: string;
  /** 申请企业统一社会信用代码 */
  creditCode: string;
  /** 代理商名称 */
  agentName: string;
  /** 申请时间 */
  applyTime: string;
  /** 申请说明 */
  remark: string;
}

export interface IGroupAduitParam extends IPageParam {
  /** 企业id */
  companyId?: string;
  /** 申请企业统一社会信用代码 */
  creditCode?: string;
  /** 代理商id */
  agentId?: string;
  /** 申请时间(起) */
  applyTimeStart?: string;
  /** 申请时间(止) */
  applyTimeEnd?: string;
}

export interface IToggleGroupAduit {
  /** 申请id */
  id: number;
  /** 审批状态(1审批通过 2审批驳回) */
  auditStatus: 1 | 2;
  /** 驳回原因 */
  remark?: string;
}

export interface IGroupManage {
  id: number;
  /** 集团名称 */
  companyName: string;
  /** 集团统一社会信用代码 */
  creditCode: string;
  /** 代理商名称 */
  agentName: string;
  /** 通过时间 */
  applyTime: string;
}

export interface IGroupManageParam extends IPageParam {
  /** 集团id */
  id?: number;
  /** 代理商id */
  agentId?: string;
  /** 集团统一社会信用代码 */
  creditCode?: string;
  /** 通过时间(起) */
  applyTimeStart?: string;
  /** 通过时间(止) */
  applyTimeEnd?: string;
}

export interface IGroupCenterLogs {
  /** 变动企业名称 */
  companyName: string;
  /** 变动企业统一社会信用代码 */
  creditCode: string;
  /** 代理商名称 */
  agentName: string;
  /** 操作时间 */
  applyTime: string;
  /** 操作人员 */
  userName?: string;
  /**
   * 操作类型
   * @description 0企业申请中 1审核通过 2审核驳回 3撤销申请 4邀请企业 5邀请撤销 6企业同意 7企业拒绝 8企业解除绑定 9集团解除绑定 10企业操作降级 11后台操作降级
   */
  typeStr?: string;
  /** 操作说明 */
  remark: string;
}

export interface IGroupCenterLogsParam extends IPageParam {
  /** 变动企业id */
  companyId?: string;
  /** 变动企业统一社会信用代码 */
  creditCode?: string;
  /** 代理商id */
  agentId?: string;
  /** 操作人员 */
  userName?: string;
  /** 操作类型 */
  type?: EGroupLogType;
  /** 操作时间(起) */
  applyTimeStart?: string;
  /** 操作时间(止) */
  applyTimeEnd?: string;
}

export enum EGroupLogType {
  /** 企业申请中 */
  Applying = 0,
  /** 审核通过 */
  Aduited = 1,
  /** 审核驳回 */
  Rejected = 2,
  /** 撤销申请 */
  Canceled = 3,
  /** 邀请企业 */
  Inviting = 4,
  /** 邀请撤销 */
  InviteCanceled = 5,
  /** 企业同意 */
  Agree = 6,
  /** 企业拒绝 */
  Refuse = 7,
  /** 企业解除绑定 */
  UnBind = 8,
  /** 集团解除绑定 */
  GroupUnBind = 9,
  /** 企业操作降级 */
  CompanyDowngrade = 10,
  /** 后台操作降级 */
  AdminDowngrade = 11,
  // 操作授权申请
  OPERATE_AUTH_APPLY = 12,
  // 操作授权取消申请
  OPERATE_AUTH_CANCEL = 13,
  // 操作授权确认
  OPERATE_AUTH_CONFIRM = 14,
  // 操作授权解除
  OPERATE_AUTH_REVOKE = 15,
  // "操作授权作废"
  OPERATE_AUTH_VOID = 16
}

export const groupLogNames = {
  [EGroupLogType.Applying]: '企业申请中',
  [EGroupLogType.Aduited]: '审核通过',
  [EGroupLogType.Rejected]: '审核驳回',
  [EGroupLogType.Canceled]: '撤销申请',
  [EGroupLogType.Inviting]: '邀请企业',
  [EGroupLogType.InviteCanceled]: '邀请撤销',
  [EGroupLogType.Agree]: '企业同意',
  [EGroupLogType.Refuse]: '企业拒绝',
  [EGroupLogType.UnBind]: '企业解除绑定',
  [EGroupLogType.GroupUnBind]: '集团解除绑定',
  [EGroupLogType.CompanyDowngrade]: '企业操作降级',
  [EGroupLogType.AdminDowngrade]: '后台操作降级',
  [EGroupLogType.OPERATE_AUTH_APPLY]: '操作授权申请',
  [EGroupLogType.OPERATE_AUTH_CANCEL]: '操作授权取消申请',
  [EGroupLogType.OPERATE_AUTH_CONFIRM]: '操作授权确认',
  [EGroupLogType.OPERATE_AUTH_REVOKE]: '操作授权解除',
  [EGroupLogType.OPERATE_AUTH_VOID]: '操作授权作废',
};

export const groupCenterLogTypes = [
  {
    label: groupLogNames[EGroupLogType.Applying],
    value: EGroupLogType.Applying,
  },
  {
    label: groupLogNames[EGroupLogType.Aduited],
    value: EGroupLogType.Aduited,
  },
  {
    label: groupLogNames[EGroupLogType.Rejected],
    value: EGroupLogType.Rejected,
  },
  {
    label: groupLogNames[EGroupLogType.Canceled],
    value: EGroupLogType.Canceled,
  },
  {
    label: groupLogNames[EGroupLogType.CompanyDowngrade],
    value: EGroupLogType.CompanyDowngrade,
  },
  {
    label: groupLogNames[EGroupLogType.AdminDowngrade],
    value: EGroupLogType.AdminDowngrade,
  },
];

/** ============= 集团管理 ============== */

/** 子企业管理 */
export interface IGroupSubCompany {
  /** 企业ID */
  id: number;
  /** 企业名称 */
  companyName?: string;
  /** 统一社会信用代码 */
  creditCode?: string;
  /** 联系人 */
  contactName?: string;
  /** 联系人手机号 */
  contactPhone?: string;
  /** 申请时间 */
  applyTime?: string;
}

/** 子企业管理 params */
export interface IGroupSubCompanyParam extends IPageParam {
  /** 企业id */
  id?: string;
  /** 申请企业统一社会信用代码 */
  creditCode?: string;
  /** 联系人 */
  contactName?: string;
  /** 联系人手机号 */
  contactPhone?: string;
  /** 绑定时间(起) */
  applyTimeStart?: string;
  /** 绑定时间(止) */
  applyTimeEnd?: string;
}

/** 待我方确认 */
export interface IGroupConfirm {
  /** 申请ID */
  id: number;
  /** 企业名称 */
  companyName?: string;
  /** 统一社会信用代码 */
  creditCode?: string;
  /** 联系人 */
  contactName?: string;
  /** 联系人手机号 */
  contactPhone?: string;
  /** 申请说明 */
  remark?: string;
  /** 申请时间 */
  applyTime?: string;
}

/** 待我方确认 params */
export interface IGroupConfirmParam extends IPageParam {
  /** 企业id */
  id?: number;
  /** 统一社会信用代码 */
  creditCode?: string;
  /** 联系人 */
  contactName?: string;
  /** 联系人手机号 */
  contactPhone?: string;
  /** 申请时间(起) */
  applyTimeStart?: string;
  /** 申请时间(止) */
  applyTimeEnd?: string;
}

/** 待对方确认 */
export interface IGroupOtherConfirm {
  /** 申请ID */
  id: number;
  /** 企业名称 */
  companyName?: string;
  /** 统一社会信用代码 */
  creditCode?: string;
  /** 联系人 */
  contactName?: string;
  /** 联系人手机号 */
  contactPhone?: string;
  /** 邀请说明 */
  remark?: string;
  /** 申请时间 */
  applyTime?: string;
}

/** 待对方确认 params */
export interface IGroupOtherConfirmParam extends IPageParam {
  /** 企业id */
  id?: string;
  /** 统一社会信用代码 */
  creditCode?: string;
  /** 联系人 */
  contactName?: string;
  /** 联系人手机号 */
  contactPhone?: string;
  /** 申请时间(起) */
  applyTimeStart?: string;
  /** 申请时间(止) */
  applyTimeEnd?: string;
}

/** 操作记录 params */
export interface IGroupAccLog {
  /** 企业名称 */
  companyName?: string;
  /** 企业统一社会信用代码 */
  creditCode?: string;
  /** 操作人 */
  userName?: string;
  /** 操作类型 */
  type?: EGroupLogType;
  /**
   * 操作类型str
   * @description (0企业申请中 1审核通过 2审核驳回 3撤销申请 4邀请企业 5邀请撤销 6企业同意 7企业拒绝 8企业解除绑定 9集团解除绑定 10企业操作降级 11后台操作降级)
   */
  typeStr?: string;
  /** 操作时间 */
  applyTime?: string;
  /** 申请说明 */
  remark?: string;
}

/** 操作记录 params */
export interface IGroupAccLogsParam extends IPageParam {
  /** 企业id */
  companyId?: string;
  /** 企业统一社会信用代码 */
  creditCode?: string;
  /** 操作人 */
  userName?: string;
  /** 联系人手机号 */
  type?: EGroupLogType;
  /** 操作时间(起) */
  applyTimeStart?: string;
  /** 操作时间(止) */
  applyTimeEnd?: string;
}

export interface IToggleGroupAccAduit {
  /** 申请id */
  id: number;
  /** 审批状态(1审批通过 2审批驳回) */
  auditStatus: 1 | 2;
  /** 驳回原因 */
  remark?: string;
}

export const groupAccLogTypes = [
  {
    label: groupLogNames[EGroupLogType.Applying],
    value: EGroupLogType.Applying,
  },
  {
    label: groupLogNames[EGroupLogType.Aduited],
    value: EGroupLogType.Aduited,
  },
  {
    label: groupLogNames[EGroupLogType.Rejected],
    value: EGroupLogType.Rejected,
  },
  {
    label: '企业撤销',
    value: EGroupLogType.Canceled,
  },
  {
    label: groupLogNames[EGroupLogType.Inviting],
    value: EGroupLogType.Inviting,
  },
  {
    label: groupLogNames[EGroupLogType.InviteCanceled],
    value: EGroupLogType.InviteCanceled,
  },
  {
    label: groupLogNames[EGroupLogType.Agree],
    value: EGroupLogType.Agree,
  },
  {
    label: groupLogNames[EGroupLogType.Refuse],
    value: EGroupLogType.Refuse,
  },
  {
    label: groupLogNames[EGroupLogType.CompanyDowngrade],
    value: EGroupLogType.CompanyDowngrade,
  },
  {
    label: groupLogNames[EGroupLogType.AdminDowngrade],
    value: EGroupLogType.AdminDowngrade,
  },
  {
    label: groupLogNames[EGroupLogType.OPERATE_AUTH_APPLY],
    value: EGroupLogType.OPERATE_AUTH_APPLY,
  },
  {
    label: groupLogNames[EGroupLogType.OPERATE_AUTH_CANCEL],
    value: EGroupLogType.OPERATE_AUTH_CANCEL,
  },
  {
    label: groupLogNames[EGroupLogType.OPERATE_AUTH_CONFIRM],
    value: EGroupLogType.OPERATE_AUTH_CONFIRM,
  },
  {
    label: groupLogNames[EGroupLogType.OPERATE_AUTH_REVOKE],
    value: EGroupLogType.OPERATE_AUTH_REVOKE,
  },
  {
    label: groupLogNames[EGroupLogType.OPERATE_AUTH_VOID],
    value: EGroupLogType.OPERATE_AUTH_VOID,
  },

];

export interface IGroupCompany {
  id: number;
  /** 代理商ID */
  agentId?: number;
  /** 企业名称 */
  companyName?: string;
  /** 申请企业统一社会信用代码 */
  creditCode?: string;
  /**
   * 企业类型(ENTERPRISE 公司 PROPRIETOR 个体户)
   * @description type {@link ECompanyType}
   */
  type?: ECompanyType;
  /** 联系人姓名 */
  contactName?: string;
  /** 联系人手机号 */
  contactPhone?: string;
  /** 是否开启0关闭1开启 */
  enable?: 0 | 1;
}

export interface IFromGroupInvite {
  /** 申请ID */
  id?: number;
  /** 企业名称 */
  companyName?: string;
  /** 统一社会信用代码 */
  creditCode?: string;
  /** 备注 */
  remark: string;
  /** 申请时间 */
  applyTime: string;
}

export enum EGroupOperateAuthStatus {
  /** 申请中 */
  PENDING = 'PENDING',
  /** 已授权 */
  AUTHORIZED = 'AUTHORIZED',
  /** 未授权 */
  UNAUTHORIZED= 'UNAUTHORIZED',
}

export const groupOperateAuthStatusLabel = {
  [EGroupOperateAuthStatus.PENDING]: '申请中',
  [EGroupOperateAuthStatus.AUTHORIZED]: '已授权',
  [EGroupOperateAuthStatus.UNAUTHORIZED]: '未授权',
};
